import './BilingualTranslate.less';
import Icon from '@/components/iconfont/Icon';
import { useState, useContext, useEffect, useCallback, useRef } from 'react';
import { EditContext } from '@/context/EditContext';
import { formatMilliseconds } from '@/utils/dayjs';
import { projectController } from '@/api/edit';
import { useWebSocket } from '@/hooks/useWebSocket.js';
import { MessageEventType } from '@/utils/socket.js';
import EditPopUp from '../../popup/Popup';
import message from '@/utils/message';
import {
  updateMaterial,
  modifySentence,
  changeTranslation,
  generatingSentence,
  modifySpeaker,
  generatingSentenceAll,
  modifySentenceEditState,
} from '@/components/Timeline/command.ts';
import { useTranslation } from 'react-i18next';
import { fullDownloadAudio } from '@/components/Timeline/utils.ts';
import play from '@/assets/edit/play.svg';
import pause from '@/assets/edit/pause.svg';
import soundwave from '@/assets/edit/soundwave.gif';
import soundwavePic from '@/assets/edit/soundwavePic.png';
import { langeImages } from '../flag.js';
import UpdateAll from '@/assets/edit/updateAll.svg';
export default function BilingualTranslate({ playState, getTimelineController }) {
  const { t } = useTranslation();
  const {
    projectDetail,
    // setProjectDetail,
    editTargetLanguageList,
    editOriginalLanguageList,
    sessionId,
    clickOutsideListener,
    sentenceMaterial,
    translationMaterial,
    setTranslationMaterial,
    // setCurrentSentenceItem,
    // setTimelinePlaybackTime,
    // currentSentenceItem,
    speakerList,
    speakerColorList,
    setSpeakerList,
    setSelectSpeakerItem,
    setShowVoiceList,
    languageCheckShow,
    setLanguageCheckShow,
    translationLanguage,
    setTranslationLanguage,
    timelinePlaybackTime,
    changeVoiceEditSentence,
    setCopeProjectPop,
    setTtstranslationPop,
    setIsInputFocused,
    sortByTimeLineFrom,
    subtitlePlayItem,
    setSubtitlePlayItem,
    mode,
    setSentenceMaterial,
    setChangeVoiceEditSentence,
  } = useContext(EditContext);
  const [clickSentencesItem, setClickSentencesItem] = useState({});
  const [textLengths, setTextLengths] = useState({});
  const [sentences, setSentences] = useState([]);
  const [languageName, setLanguageName] = useState('');
  const [translationLanguageName, settranslationLanguageName] = useState('');
  const [addSpeakerLoading, setAddSpeakerLoading] = useState(false);
  const [textId, setTextId] = useState(0);
  const [targetLanguageToSwitch, setTargetLanguageToSwitch] = useState('');
  const [activeItem, setActiveItem] = useState(-1);
  const pauseTimeline = useRef(null);
  const [flogPic, setFlogPic] = useState(null);
  const [updateAllShow, setUpdateAllShow] = useState(false);
  const [updateAllFlag, setUpdateAllFlag] = useState(false);
  const ttsSentenceNum = useRef(1);
  const isTtsAll = useRef(false);
  useWebSocket(
    MessageEventType.TTS_DETAIL,
    useCallback(
      async ({ detail, extraDetail, isSucceed, projectId }) => {
        if (!isSucceed) {
          message.error('Speech generated failed, please retry', {
            id: 'tts',
          });
        }

        const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));

        if (projectItem.id === projectId) {
          // translationMaterial.details.filter((item) => {
          //   if (Number(detail.id) === Number(item.id)) {
          //     Object.assign(item, detail);
          //   }
          // });
          // setTranslationMaterial({ ...translationMaterial });
          // await preloadAudio({ details: [detail] });
          detail.sentenceUrl = detail.sentenceUrl.replace('talecast.ai', 'addsubtitle.ai');

          await fullDownloadAudio({ details: [detail] }); // 全量下载

          const index = translationMaterial.details.findIndex(
            (item) => Number(item.id) === Number(detail.id),
          );
          if (index !== -1) {
            translationMaterial.details[index] = JSON.parse(JSON.stringify(detail));
          }

          const sentenceMaterialIndex = sentenceMaterial.details.findIndex(
            (item) => Number(item.id) === Number(extraDetail.id),
          );
          if (sentenceMaterialIndex !== -1) {
            sentenceMaterial.details[sentenceMaterialIndex] = JSON.parse(
              JSON.stringify(extraDetail),
            );
          }
          // translationMaterial.details = translationMaterial.details.map((item) => {
          //   if (Number(item.id) === Number(detail.id)) {
          //     item = JSON.parse(JSON.stringify(detail));
          //   }
          //   return item;
          // });
          // sentenceMaterial.details = sentenceMaterial.details.map((item) => {
          //   if (Number(item.id) === Number(extraDetail.id)) {
          //     item = JSON.parse(JSON.stringify(extraDetail));
          //   }
          //   return item;
          // });
          setSentenceMaterial({ ...sentenceMaterial });
          setTranslationMaterial({ ...translationMaterial });
          setTimeout(() => {
            modifySentenceEditState(4, detail.id, false);
            updateMaterial(detail, 'tts');
          }, 10);
        }
      },
      [translationMaterial, sentenceMaterial, mode],
    ),
  );
  useEffect(() => {
    if (JSON.stringify(sentenceMaterial) === '{}') return;
    let combinedSentences;
    if (mode === 'translation_and_tts') {
      const hasIsEdit = translationMaterial.details.some((item) => item.isEdit === true);
      if (hasIsEdit) {
        setUpdateAllFlag(false);
        setUpdateAllShow(true);
      } else {
        const hasGenerating = translationMaterial.details.some((item) => item.generating === true);
        if (hasGenerating) {
          setUpdateAllFlag(true);
        } else {
          setUpdateAllShow(false);
        }
      }
      combinedSentences = translationMaterial.details.map((translation) => {
        const sentence = sentenceMaterial.details?.find(
          (item) => Number(item.id) === Number(translation.id),
        );
        const item = sentences.find((item) => Number(item.id) === Number(sentence.id));
        return {
          ...item,
          ...translation,
          id: Number(sentence.id),
          sentence: sentence.sentence?.replace(/\[__SPACE__\]/g, '') || '',
          timeLineFrom_original: sentence?.timeLineFrom,
          timeLineFrom: translation.timeLineFrom,
          timeLineTo_original: sentence?.timeLineTo,
          timeLineTo: translation.timeLineTo,
          placeholderShow: !translation.sentence?.replace(/\[__SPACE__\]/g, ''),
          translation: translation?.sentence?.replace(/\[__SPACE__\]/g, '') || '',
          translationAudio: translation?.sentenceUrl || '',
          sentenceAudio: sentence?.sentenceUrl || '',
          speed: translation.speed,
          speed_original: sentence.speed,
        };
      });
    } else {
      const hasIsEdit = sentenceMaterial.details.some((item) => item.isEdit === true);
      if (hasIsEdit) {
        setUpdateAllFlag(false);
        setUpdateAllShow(true);
      } else {
        const hasGenerating = sentenceMaterial.details.some((item) => item.generating === true);
        if (hasGenerating) {
          setUpdateAllFlag(true);
        } else {
          setUpdateAllShow(false);
        }
      }
      combinedSentences = sentenceMaterial.details.map((sentence) => {
        const translation = translationMaterial.details?.find(
          (item) => Number(item.id) === Number(sentence.id),
        );
        const item = sentences.find((item) => Number(item.id) === Number(sentence.id));
        return {
          ...item,
          ...translation,
          id: Number(sentence.id),
          sentence: sentence.sentence?.replace(/\[__SPACE__\]/g, '') || '',
          timeLineFrom: sentence.timeLineFrom,
          timeLineTo: sentence.timeLineTo,
          placeholderShow: !translation.sentence?.replace(/\[__SPACE__\]/g, ''),
          translation: translation?.sentence?.replace(/\[__SPACE__\]/g, '') || '',
          translationAudio: translation?.sentenceUrl || '',
          sentenceAudio: sentence?.sentenceUrl || '',
        };
      });
    }

    setSentences(combinedSentences);
    const initialLengths = {};
    combinedSentences.forEach((item) => {
      initialLengths[item.id] = item.translation?.length || 0;
    });

    setTextLengths((prev) => ({
      ...prev,
      ...initialLengths,
    }));
  }, [sentenceMaterial, translationMaterial, mode]);

  useEffect(() => {
    if (translationLanguage) {
      const translationLanguageItem = editTargetLanguageList.find(
        (item) => item.id === translationLanguage,
      );

      if (translationLanguageItem !== -1) {
        settranslationLanguageName(translationLanguageItem.language);
      }
    }
    if (projectDetail.language) {
      const language = editOriginalLanguageList.find((item) => item.id === projectDetail.language);
      console.log(language, 'language');

      if (language !== -1 && language !== undefined) {
        setLanguageName(language?.language);
      }
    }
  }, [translationLanguage, projectDetail.language]);

  useEffect(() => {
    if (clickOutsideListener) {
      //  关闭所有的句子更多操作的下拉框;
      if (
        !clickOutsideListener.target.closest('.more_box_option') &&
        !clickOutsideListener.target.closest('.more_operations')
      ) {
        setSentences((prevSentences) =>
          prevSentences.map((sentence) => ({ ...sentence, moreShow: false })),
        );
      }
      if (
        !clickOutsideListener.target.closest('.speaker_label') &&
        !clickOutsideListener.target.closest('.speaker_list_box') &&
        !clickOutsideListener.target.closest('.add_speaker')
      ) {
        setSentences((prevSentences) =>
          prevSentences.map((sentence) => ({ ...sentence, speakerShow: false })),
        );
      }
    }
  }, [clickOutsideListener]);
  // 点击某个句子
  // const handleSentenceItem = (item) => {
  //   // setCurrentSentenceItem(item);
  //   // setTimelinePlaybackTime(item.timeLineFrom);
  //   setClickSentencesItem(item);
  // };
  //   点击某个句子上的更多操作
  const handleMoreClick = (item, index) => {
    // 先将所有moreShow置为false，再修改对应点击项的moreShow为true
    setSentences((prevSentences) =>
      prevSentences.map((sentence) => ({ ...sentence, moreShow: false })),
    );
    const updatedItem = { ...item, moreShow: !item.moreShow };
    // setCurrentSentenceItem(updatedItem);
    // setTimelinePlaybackTime(updatedItem.timeLineFrom);
    // setClickSentencesItem(updatedItem);
    setSentences((prevSentences) =>
      prevSentences.map((sentence, idx) => (idx === index ? updatedItem : sentence)),
    );
  };

  //   点击某个句子上的speaker列表操作
  const handleSpeakerClick = (item, index) => {
    if (item.generating) {
      setSentences((prevSentences) =>
        prevSentences.map((sentence) => ({ ...sentence, speakerShow: false })),
      );
      return;
    }
    window.onClickGATrackEvent('speaker-click');
    // 先将所有speakerShow置为false，再修改对应点击项的speakerShow为true
    setSentences((prevSentences) =>
      prevSentences.map((sentence) => ({ ...sentence, speakerShow: false })),
    );
    const updatedItem = { ...item, speakerShow: item.speakerShow };
    // setCurrentSentenceItem(updatedItem);
    // setTimelinePlaybackTime(updatedItem.timeLineFrom);
    setClickSentencesItem(updatedItem);
    setSentences((prevSentences) =>
      prevSentences.map((sentence, idx) => (idx === index ? updatedItem : sentence)),
    );
  };

  // 计算speaker_list_box的弹出位置
  const calculatePopupPosition = (e) => {
    const speakerLabel = e.currentTarget;
    const speechMain = document.querySelector('.speech_main');

    if (!speakerLabel || !speechMain) return {};

    const labelRect = speakerLabel.getBoundingClientRect();
    const mainRect = speechMain.getBoundingClientRect();

    // 默认向下弹出
    let position = { top: '100%', bottom: 'auto' };

    // 计算向下弹出时，列表底部的位置
    const estimatedHeight = 150; // 假设列表高度约为150px
    const spaceBelow = mainRect.bottom - labelRect.bottom;

    // 如果下方空间不足，则向上弹出
    if (spaceBelow < estimatedHeight) {
      position = { bottom: '100%', top: 'auto' };
    }

    return position;
  };

  const handleClickSentenceItem = (item) => {
    setClickSentencesItem(item);
  };

  const handleChangeSentence = (e, item) => {
    const value = e.target.textContent;
    item.isEdit = true;
    if (value) {
      item.placeholderShow = false;
    } else {
      item.placeholderShow = true;
    }

    // 单独更新文本长度
    setTextLengths((prev) => ({
      ...prev,
      [item.id]: value.length,
    }));
  };

  const handleInputBlur = (e) => {
    const content = e.target.textContent;
    const value = content.slice(0, 1000); // 限制长度

    // 如果内容超过限制或有多余空格，更新 DOM 显示
    if (content !== value) {
      e.target.textContent = value;
    }
    return value;
  };

  const editSentence = async (item, value) => {
    const targetIndex = translationMaterial.details.findIndex(
      (detail) => Number(detail.id) === Number(item.id),
    );
    setClickSentencesItem({});
    if (targetIndex !== -1) {
      if (value === translationMaterial.details[targetIndex].sentence) return;
      translationMaterial.details[targetIndex].sentence = value;
      translationMaterial.details[targetIndex].isEdit = true;
      setTranslationMaterial({ ...translationMaterial });
    } else {
      return;
    }
    modifySentenceEditState(4, item.id, true);
    modifySentence(4, item.id, value);
    const obj = translationMaterial.details[targetIndex];

    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      projectController.timelineOp({
        projectId: projectItem.id,
        body: {
          sessionId,
          timelineOpTypeEnum: 1,
          isTranslation: true,
          language: translationLanguage,
          materialDetail: obj,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // 阻止默认的换行行为
      e.target.blur(); // 使元素失焦
      setClickSentencesItem({});
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();

    // 获取纯文本，避免粘贴格式
    const pastedText = e.clipboardData.getData('text/plain');

    // 获取当前选择范围
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);

    // 插入文本
    const textNode = document.createTextNode(pastedText);
    range.deleteContents();
    range.insertNode(textNode);

    // 将光标移动到插入文本的末尾
    range.setStartAfter(textNode);
    range.setEndAfter(textNode);
    selection.removeAllRanges();
    selection.addRange(range);
  };

  // 新增speaker
  const handleAddSpeaker = async () => {
    window.onClickGATrackEvent('speaker-add');
    setAddSpeakerLoading(true);
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      const res = await projectController.addSpeaker({
        projectId: projectItem.id,
      });
      console.log(res);
      if (res.code === 0) {
        const obj = {
          ...res.data,
          voiceId: '',
          voiceName: '',
        };
        setSpeakerList((prevList) => [...prevList, obj]);
      }
    } catch (error) {
      console.log(error);
    }
    setAddSpeakerLoading(false);
  };
  const handleChangeVoice = (item, speakerItem) => {
    setSelectSpeakerItem(speakerItem);
    setShowVoiceList(true);
  };
  useEffect(() => {
    if (changeVoiceEditSentence.date === 0) return;
    const item = changeVoiceEditSentence.item;
    const nowItem = speakerList.find((its) => its.speakerId === item.speakerId);
    if (nowItem.voiceNumber !== item.voiceNumber) {
      translationMaterial.details.filter((detail) => {
        if (item.speakerId === detail.speakerId && detail.sentence) {
          detail.isEdit = true;
        }
      });
      setTranslationMaterial({ ...translationMaterial });
    }

    setChangeVoiceEditSentence({
      item,
      date: 0,
    });
  }, [changeVoiceEditSentence, speakerList]);

  const handleShowLanguageList = () => {
    setLanguageCheckShow(!languageCheckShow);
  };

  const handleDeleteItem = (item) => {
    console.log(subtitlePlayItem, item, 'subtitlePlayItem');
    if (Number(item.id) === Number(subtitlePlayItem?.id)) {
      setSubtitlePlayItem({});
    }
    const targetIndex = translationMaterial.details.findIndex(
      (detail) => Number(detail.id) === Number(item.id),
    );
    if (targetIndex !== -1) {
      translationMaterial.details[targetIndex].sentence = '';
      setTranslationMaterial({ ...translationMaterial });
    } else {
      return;
    }
    setSentences((prevSentences) =>
      prevSentences.map((sentence) => ({ ...sentence, moreShow: false })),
    );
    modifySentence(4, item.id, '');
    const obj = translationMaterial.details[targetIndex];
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      projectController.timelineOp({
        projectId: projectItem.id,
        body: {
          sessionId,
          timelineOpTypeEnum: 1,
          isTranslation: true,
          language: translationLanguage,
          materialDetail: obj,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
  const handleChageTargetLanguageItem = async (language) => {
    setTargetLanguageToSwitch(language.id);
    // 判断语种是否已经翻译
    if (projectDetail.translatedLanguages?.includes(language.id)) {
      setTranslationLanguage(language.id);
      const info = await projectTranslate(false, language.id, 'switch');
      translationMaterial.details = sortByTimeLineFrom(info.data.translateDetails);
      setTranslationMaterial({ ...translationMaterial });
      setTimeout(() => {
        changeTranslation();
      });
    } else {
      setCopeProjectPop(true);
    }
  };
  const projectTranslate = async (generateSpeech = false, languageCode = '') => {
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      const res = await projectController.translate({
        projectId: projectItem.id,
        body: {
          sessionId,
          languageCode: languageCode || targetLanguageToSwitch,
          generateSpeech,
        },
      });
      return res;
    } catch (error) {
      console.log(error);
    }
  };
  // 删除句子tts
  const clearSpeechTTS = (item) => {
    const targetIndex = translationMaterial.details.findIndex(
      (detail) => Number(detail.id) === Number(item.id),
    );
    const obj = translationMaterial.details[targetIndex];
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      projectController.timelineOp({
        projectId: projectItem.id,
        body: {
          sessionId,
          timelineOpTypeEnum: 8,
          isTranslation: true,
          materialDetail: obj,
          language: projectDetail.translationLanguage,
        },
      });
      translationMaterial.details[targetIndex].timeLineTo =
        translationMaterial.details[targetIndex].timeLineFrom;
      translationMaterial.details[targetIndex].sentenceUrl = '';
      translationMaterial.details[targetIndex].isEdit = false;
      translationMaterial.details[targetIndex].subtitle.text = '';
      translationMaterial.details[targetIndex].subtitle.timeLineFrom =
        translationMaterial.details[targetIndex].subtitle.timeLineTo;
      setTranslationMaterial({ ...translationMaterial });
      updateMaterial(translationMaterial.details[targetIndex]);
    } catch (error) {
      console.log(error);
    }
  };
  const handleUpdateSpeech = (item) => {
    if (!textLengths[item.id]) {
      clearSpeechTTS(item);
      return;
    }
    const sentence = sentences.find((res) => res.id === item.id);
    if (sentence && sentence.translationPlayState) {
      pauseTimeline.current && pauseTimeline.current();
    }
    window.onClickGATrackEvent('speech-update', {
      tts_mode: 'translate_text',
    });
    const speakerItem = speakerList.find((detail) => detail.speakerId === item.speakerId);
    if (!speakerItem.voiceNumber) {
      setSelectSpeakerItem(speakerItem);
      setShowVoiceList(true);
      return;
    }

    // 判断是否不在提醒
    setTextId(item.id);
    isTtsAll.current = false;
    ttsSentenceNum.current = 1;
    setTtstranslationPop(true);
  };
  const projectTextToSpeech = (id, errorCallback) => {
    const targetIndex = translationMaterial.details.findIndex(
      (detail) => Number(detail.id) === Number(id),
    );

    if (targetIndex !== -1) {
      translationMaterial.details[targetIndex].generating = true;
      translationMaterial.details[targetIndex].isEdit = false;
      setTranslationMaterial({ ...translationMaterial });
    }
    setTimeout(() => {
      generatingSentence(translationMaterial.details[targetIndex]);
      const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
      try {
        projectController.timelineOp({
          projectId: projectItem.id,
          body: {
            sessionId,
            timelineOpTypeEnum: 6,
            isTranslation: true,
            language: translationLanguage,
            indexes: [id],
            materialDetail: {
              type: 4,
            },
          },
        });
      } catch (error) {
        console.error(error);
        errorCallback();
      }
    }, 10);
  };

  const handleCheckSpeaker = (item, speakerItem) => {
    window.onClickGATrackEvent('speaker-change');
    const targetIndex = translationMaterial.details.findIndex(
      (detail) => Number(detail.id) === Number(item.id),
    );
    if (targetIndex !== -1) {
      translationMaterial.details[targetIndex].speakerId = speakerItem.speakerId;
      translationMaterial.details[targetIndex].isEdit = true;
      setTranslationMaterial({ ...translationMaterial });
    }

    setSentences((prevSentences) =>
      prevSentences.map((sentence) => ({ ...sentence, speakerShow: false })),
    );
    modifySpeaker(4, item.id, speakerItem.speakerId);
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      projectController.timelineOp({
        projectId: projectItem.id,
        body: {
          sessionId,
          timelineOpTypeEnum: 1,
          isTranslation: true,
          language: translationLanguage,
          materialDetail: translationMaterial.details[targetIndex],
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
  const changePlayState = (item, type, state) => {
    if (state) {
      pauseTimeline.current && pauseTimeline.current();
      return;
    }
    const listenItem = sentences.find((res) => res.id === item.id);
    const canNotChangePlayState =
      type === 0
        ? listenItem.timeLineFrom_original >= listenItem.timeLineTo_original
        : listenItem.timeLineFrom >= listenItem.timeLineTo;
    if (canNotChangePlayState) return;
    // type: 0 原文 1 译文
    setSentences((prevSentences) =>
      prevSentences.map((res) => {
        res.originalPlayState = res.id === item.id && type === 0 ? !res.originalPlayState : false;
        res.translationPlayState =
          res.id === item.id && type === 1 ? !res.translationPlayState : false;
        const isPlay =
          res.id === item.id &&
          ((type === 0 && res.originalPlayState) || (type === 1 && res.translationPlayState));
        if (isPlay) {
          pauseTimeline.current =
            getTimelineController &&
            getTimelineController({
              start: type === 0 ? item.timeLineFrom_original / 1000 : item.timeLineFrom / 1000,
              url: type === 0 ? item.sentenceAudio : item.translationAudio,
              end: type === 0 ? item.timeLineTo_original / 1000 : item.timeLineTo / 1000,
              speed: type === 0 ? item.speed_original : item.speed,
              id: item.id,
              isTranslation: !!type,
            });
        }
        return res;
      }),
    );
  };
  useEffect(() => {
    if (!playState) {
      setSentences((prevSentences) =>
        prevSentences.map((res) => ({
          ...res,
          originalPlayState: false,
          translationPlayState: false,
        })),
      );
    }
  }, [playState]);
  useEffect(() => {
    const flogPic = langeImages.find((res) => res.id === projectDetail.translationLanguage).image;
    setFlogPic(flogPic);
  }, []);
  const handleTtsAll = () => {
    const speakerNoVoice = [];
    sentences.forEach((item) => {
      const speakerItem = speakerList.find((detail) => detail.speakerId === item.speakerId);
      if (!speakerItem.voiceName) {
        speakerNoVoice.push(speakerItem);
      }
    });
    if (speakerNoVoice.length > 0) {
      setSelectSpeakerItem(speakerNoVoice[0]);
      setShowVoiceList(true);
      return;
    }
    ttsSentenceNum.current = 0;
    if (mode === 'translation_and_tts') {
      translationMaterial.details.forEach((detail) => {
        if (detail.isEdit && !detail.generating) {
          ttsSentenceNum.current += 1;
        }
      });
    } else {
      sentenceMaterial.details.forEach((detail) => {
        if (detail.isEdit && !detail.generating) {
          ttsSentenceNum.current += 1;
        }
      });
    }

    isTtsAll.current = true;
    setTtstranslationPop(true);
  };
  const handleUpdateAll = (errorCallback) => {
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    setUpdateAllFlag(true);
    if (mode === 'translation_and_tts') {
      translationMaterial.details.filter((detail) => {
        if (detail.isEdit && detail.sentence) {
          detail.generating = true;
          detail.isEdit = false;
        }
      });
      setTranslationMaterial({ ...translationMaterial });
    } else {
      sentenceMaterial.details.filter((detail) => {
        if (detail.isEdit && detail.sentence) {
          detail.generating = true;
          detail.isEdit = false;
        }
      });
      setSentenceMaterial({ ...sentenceMaterial });
    }
    setTimeout(() => {
      generatingSentenceAll(translationMaterial.details);
    }, 20);
    try {
      projectController.batchTts({ sessionId, projectId: projectItem.id });
    } catch (error) {
      console.log(error);
      setUpdateAllFlag(false);
      errorCallback();
    }
  };
  return (
    <div className="speech_bilingual_translate_sentence">
      <div className="bilingual_speech_title_box">
        <div className="bilingual_speech_title">{t('As_Edit_SpaceVoice334')}</div>
        {updateAllShow && (
          <div
            className={`bilingual_speech_updateall  ${!updateAllFlag && 'bilingual_updateall_hover'}`}
            onClick={() => {
              !updateAllFlag && handleTtsAll();
            }}>
            {t('As_Edit_UpdateAll334')}
            {updateAllFlag ? (
              <span className="loading loading-spinner loading-xs"></span>
            ) : (
              <img src={UpdateAll} alt="" />
            )}
          </div>
        )}
      </div>
      <div className="language_switch" style={{ display: 'none' }}>
        <div className="language_switch_item">
          {t('As_Edit_SpeechChoice1')} ({languageName})
        </div>
        <div className="translation_select_language_box">
          <div
            className="language_switch_item translation_select_language"
            onClick={handleShowLanguageList}>
            <span>
              {t('As_Edit_SpeechChoice2')} ({translationLanguageName})
            </span>
            {!languageCheckShow && <Icon name="icon-arrow-down" />}
            {languageCheckShow && <Icon name="icon-arrow-down" />}
          </div>
          {languageCheckShow && (
            <div className="language_list_box">
              {editTargetLanguageList.map((language, index) => (
                <div
                  key={index}
                  className="language_list_item"
                  onClick={() => {
                    handleChageTargetLanguageItem(language);
                  }}>
                  <span>{language.language}</span>
                  <div className="icon_box">
                    {/*<Icon*/}
                    {/*  name="icon-Translate"*/}
                    {/*  className="icon_translate"*/}
                    {/*  style={{*/}
                    {/*    visibility: projectDetail.translatedLanguages?.includes(language.id)*/}
                    {/*      ? 'visible'*/}
                    {/*      : 'hidden',*/}
                    {/*  }}*/}
                    {/*/>*/}

                    <Icon
                      name="icon-check-stroke"
                      className="icon_check"
                      style={{
                        visibility: translationLanguage === language.id ? 'visible' : 'hidden',
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="bilingual_sentences speech_scroll_main">
        {sentences.map((item, index) => {
          return (
            <div
              data-match-index={index}
              data-field="text"
              key={index}
              className={`sentence_item ${timelinePlaybackTime >= item.timeLineFrom && timelinePlaybackTime < item.timeLineTo && 'active_sentence_item speech_active'} ${activeItem === index && 'click_info_item'}`}
              onClick={() => {
                setActiveItem(index);
                // handleSentenceItem(item);
              }}
              onMouseLeave={() => {
                setSentences((prevSentences) =>
                  prevSentences.map((sentence) => ({ ...sentence, moreShow: false })),
                );
              }}>
              {timelinePlaybackTime >= item.timeLineFrom &&
                timelinePlaybackTime < item.timeLineTo && (
                  <div
                    className="active_sentence"
                    style={{
                      backgroundColor: speakerColorList[item.speakerId - 1]?.bgColor,
                    }}></div>
                )}
              <div className="sentence_item_left">{formatMilliseconds(item.timeLineFrom)}</div>
              <div className="sentence_item_right">
                <div className="sentence_item_right_operations">
                  <div className="sentence_item_right_operations_left">
                    <div
                      className="speaker_label"
                      style={{
                        color: speakerColorList[item.speakerId - 1]?.textColor,
                        background: speakerColorList[item.speakerId - 1]?.bgColor,
                      }}>
                      <div
                        className="speaker_label_text_box"
                        onClick={(e) => {
                          e.stopPropagation();
                          const position = calculatePopupPosition(e);
                          // 将位置信息添加到item中
                          const updatedItem = {
                            ...item,
                            speakerShow: !item.speakerShow,
                            popupPosition: position,
                          };
                          handleSpeakerClick(updatedItem, index);
                        }}>
                        <div className="speaker_label_text">Speaker {item.speakerId}</div>
                        {!item.speakerShow && (
                          <Icon name="icon-arrow-down" className="speaker_label_icon" />
                        )}
                        {item.speakerShow && <Icon name="icon-arrow-left" />}
                      </div>
                      {item.speakerShow && (
                        <div className="speaker_list_box" style={item.popupPosition || {}}>
                          {speakerList.map((speakerItem, speakerIndex) => {
                            return (
                              <div
                                key={speakerIndex}
                                className={`speaker_list_item ${item.speakerId - 1 === speakerIndex && 'active_speaker_item'}`}
                                style={{
                                  color: speakerColorList[speakerIndex].textColor,
                                  '--border-color': speakerColorList[speakerIndex].textColor,
                                  '--bg-color': speakerColorList[speakerIndex].bgColor,
                                }}
                                onClick={() => {
                                  handleCheckSpeaker(item, speakerItem);
                                }}>
                                <div
                                  className="speaker_list_item_title"
                                  style={{ color: speakerColorList[speakerIndex].bgColor }}>
                                  {speakerItem.speakerName}
                                </div>
                                {speakerItem.voiceNumber && (
                                  <div
                                    className="speaker_list_item_voice_box tooltip"
                                    data-tip={speakerItem.voiceName}
                                    onClick={(e) => {
                                      e.stopPropagation(); // 阻止事件冒泡
                                      window.onClickGATrackEvent('speaker-change-voice');
                                      handleChangeVoice(item, speakerItem);
                                    }}>
                                    <div className="speaker_list_item_voice">
                                      {speakerItem.voiceName}
                                    </div>
                                    <Icon name="icon-changevoice" className="voice_icon" />
                                  </div>
                                )}
                                {!speakerItem.voiceNumber && (
                                  <div
                                    className="speaker_novoice_box"
                                    onClick={(e) => {
                                      e.stopPropagation(); // 阻止事件冒泡
                                      window.onClickGATrackEvent('speaker-select-voice');
                                      handleChangeVoice(item, speakerItem);
                                    }}>
                                    {t('As_Recording_AssetsSelect')}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                          {speakerList.length < 4 && (
                            <>
                              {!addSpeakerLoading && (
                                <div className="add_speaker" onClick={handleAddSpeaker}>
                                  <Icon name="icon-add-stroke" className="icon_add_speaker" />
                                  <span>{t('As_Edit_AddSpeaker')}</span>
                                </div>
                              )}
                              {addSpeakerLoading && (
                                <div className="add_speaker" onClick={handleAddSpeaker}>
                                  <span className="loading loading-spinner loading-xs"></span>
                                  <span>{t('As_Edit_AddSpeaker')}</span>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                    <div
                      className="audition speech_play_state"
                      style={{ marginRight: '6px' }}
                      onClick={() => changePlayState(item, 0, item.originalPlayState)}>
                      <img src={item.originalPlayState ? pause : play} className="listen" />
                      <img
                        src={item.originalPlayState ? soundwave : soundwavePic}
                        className="soundwave"
                        alt=""
                      />
                    </div>
                    <div
                      className="audition speech_play_state"
                      onClick={() => {
                        if (item.generating) return;
                        changePlayState(item, 1, item.translationPlayState);
                      }}>
                      <img
                        src={item.translationPlayState ? pause : flogPic}
                        className="listen"
                        alt=""
                      />
                      <img
                        src={item.translationPlayState ? soundwave : soundwavePic}
                        className="soundwave"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="operate">
                    {item.generating ? (
                      <div className="sentence_item_right_operations_right">
                        <div className="sentence_item_right_generating">
                          <div className="text">{t('As_Edit_Processing')}</div>
                          <span className="loading loading-spinner loading-xs"></span>
                        </div>
                      </div>
                    ) : (
                      <div className="sentence_item_right_operations_right speech_block">
                        <div
                          className={`update_speech ${(!item.isEdit || (!item.sentenceUrl && !textLengths[item.id])) && 'update_hidden'}`}
                          onClick={() => {
                            if (!item.isEdit || (!item.sentenceUrl && !textLengths[item.id]))
                              return;
                            handleUpdateSpeech(item, index);
                          }}>
                          <span>{t('As_Edit_Update334')}</span>
                          <Icon
                            name="icon-Replace"
                            className="icon_update"
                            style={{ color: item.isEdit ? '#FEA92A' : '#3BC961' }}
                          />
                        </div>
                      </div>
                    )}
                    <div className="speech_block ">
                      <div className="sentence_num">{textLengths[item.id] || 0}/1000</div>
                      <div className="more_box">
                        <div
                          className={`more_operations ${item.moreShow && 'more_icon_click'}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMoreClick(item, index);
                          }}>
                          <Icon name="icon-dot-more-horizontally" />
                        </div>
                        <div
                          className={`more_box_option btn_style ${item.moreShow && 'more_box_option_block'}`}
                          onClick={() => {
                            handleDeleteItem(item, index);
                          }}>
                          {t('As_Edit_TransClearScript')}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sentence_item_right_text">
                  <div className={`original_meaning ${item.generating && 'original_text'}`}>
                    {item.sentence}
                  </div>
                  {!item.generating && (
                    <div
                      className={`translation_text ${item.placeholderShow ? 'empty' : ''} ${Number(clickSentencesItem.id) === Number(item.id) && 'click_sentence_item'}  ${item.isEdit && 'edit_sentence_item'}`}
                      contentEditable
                      data-placeholder={t('As_Edit_AddContentReminder')}
                      suppressContentEditableWarning
                      onPaste={(e) => {
                        const updatedItem = { ...item, isEdit: true, placeholderShow: false };
                        setSentences((prevSentences) =>
                          prevSentences.map((sentence, idx) =>
                            idx === index ? updatedItem : sentence,
                          ),
                        );
                        handlePaste(e); // 调用handlePaste处理粘贴事件
                      }}
                      onKeyDown={handleKeyDown}
                      onBlur={(e) => {
                        setIsInputFocused(false);
                        const value = handleInputBlur(e, item, index);
                        editSentence(item, value);
                      }}
                      onClick={() => {
                        handleClickSentenceItem(item, index);
                      }}
                      onFocus={() => {
                        setIsInputFocused(true);
                        window.onClickGATrackEvent('click-sentence');
                      }}
                      onInput={(e) => {
                        handleChangeSentence(e, item, index);
                      }}
                      ref={(element) => {
                        if (element && item.shouldFocus) {
                          element.focus();
                          const range = document.createRange();
                          range.selectNodeContents(element);
                          range.collapse(false);
                          const selection = window.getSelection();
                          selection.removeAllRanges();
                          selection.addRange(range);
                          item.shouldFocus = false;
                        }
                      }}>
                      {item.translation}
                    </div>
                  )}
                  {item.generating && (
                    <div className="translation_text generating_translation_text">
                      {item.translation || t('As_Edit_AddContentReminder')}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <EditPopUp
        sentenceNum={sentences?.length}
        targetLanguageCode={targetLanguageToSwitch}
        onTranslate={(generateSpeech) => projectTranslate(generateSpeech)}
        ttsTextId={textId}
        ttsSentenceNum={ttsSentenceNum.current}
        onTTS={(id, errorCallback) => projectTextToSpeech(id, errorCallback)}
        onTTSAll={(errorCallback) => {
          handleUpdateAll(errorCallback);
        }}
        isTTSAll={isTtsAll.current}
      />
    </div>
  );
}
